import React, { FC, useState, useEffect } from "react";
import styled, { css } from "styled-components";

import Logo from "src/components/Logo";
import Navigation from "src/components/Navigation";
import { colors } from "src/themes/colors";
import { mediaQuery } from "src/themes/breakpoints";

const Wrapper = styled.header<HeaderProps>`
  height: 60px;
  padding: ${(props) =>
    props.$scrolled || props.isWhite ? "10px 20px" : "40px 20px"};
  position: fixed;
  top: 0;
  transition: background-color 200ms;
  width: 100%;
  z-index: 3;

  ${mediaQuery("lg")} {
    padding: ${(props) =>
      props.$scrolled || props.isWhite ? "10px 20px" : "60px 20px"};
  }

  ${({ isWhite }) =>
    isWhite &&
    css`
      background-color: ${colors.white};
      box-shadow: 0 1px 1px 0 rgba(65, 69, 73, 0.3),
        0 1px 3px 1px rgba(65, 69, 73, 0.15);
    `}
`;

const Content = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1200px;
`;

interface HeaderProps {
  isWhite?: boolean;
}

const Header: FC<HeaderProps> = ({ isWhite }) => {
  const [scroll, setScroll] = useState(false);

  const changeColors = () => {
    if (window && window.scrollY > 0) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeColors);
    return () => {
      window.removeEventListener("scroll", changeColors);
    };
  }, []);

  return (
    <Wrapper isWhite={scroll || isWhite} $scrolled={scroll}>
      <Content>
        <Logo isWhite={isWhite || scroll} />
        <Navigation isWhite={isWhite || scroll} />
      </Content>
    </Wrapper>
  );
};

export default Header;
